export default __webpack_public_path__ + "static/media/ring.5661ab82.svg";